import { useBootstrap } from "@/features/bootstrap";
import { ROLES } from "@/features/router/roles";

function firstId(arr) {
  if (!arr?.length) {
    return null;
  }

  const item = arr[0];
  return typeof item === "string" ? item : (item?._id ?? null);
}

function resolveDistrictId(user) {
  return (
    firstId(user?.districts) ??
    (user?.schools?.[0]?.district
      ? typeof user.schools[0].district === "string"
        ? user.schools[0].district
        : user.schools[0].district._id
      : null)
  );
}

export function useOrgScope() {
  const { data: user } = useBootstrap();

  if (!user) {
    return {
      userScope: null,
      schoolId: null,
      classIds: null,
      districtId: null,
    };
  }

  switch (user.role) {
    case ROLES.TECH:
      return {
        userScope: "default",
        schoolId: null,
        classIds: null,
        districtId: null,
      };
    case ROLES.SUPERADMIN:
      return {
        userScope: "district",
        districtId: firstId(user.districts),
        schoolId: firstId(user.schools),
        classIds: null,
      };
    case ROLES.ADMIN:
      return {
        userScope: "school",
        schoolId: firstId(user.schools),
        districtId: resolveDistrictId(user),
        classIds: null,
      };
    default:
      return {
        userScope: "custom",
        schoolId: firstId(user.schools),
        districtId: resolveDistrictId(user),
        classIds: user.classes?.map((cls) => {
          if (typeof cls === "string") {
            return cls;
          }
          return (cls?._id ?? cls?.id ?? cls).toString();
        }),
      };
  }
}
